<template>
    <div class="public-profile-wrapper">
        <div class="flex flex-column md:px-4 lg:flex-row gap-4 mt-4 justify-content-center">
            <div class="w-full md:p-4">
                <div class="py-4">
                    <div class="grid" v-if="enrolledStudents?.length > 0">
                        <div v-for="(student, index) in enrolledStudents" :key="student.studentId || index"
                            class="col-12 sm:col-4 lg:col-3 mb-3">
                            <div class="surface-section">
                                <div class="flex align-items-center gap-3 mb-2">
                                    <img :src="student.profilePhoto || blankProfile" class="w-full h-full"
                                        :alt="student.studentName" />
                                </div>
                                <div class="p-3">
                                    <div>
                                        <div class="flex flex-wrap justify-content-between align-items-center">
                                            <div class="Raleway font-semibold mb-2">{{ student.studentName }}</div>
                                            <Button icon="pi pi-comments" label=""
                                                class="p-button-text Caption mb-2 black-btn " />
                                        </div>

                                        <!-- <div class=" Raleway-Medium mb-2">{{ student.grade }}</div> -->
                                        <div class=" Raleway-Medium mb-2">{{ student.classModes.join(' & ') }}</div>
                                    </div>
                                    <div class="flex flex-column gap-1 text-sm">
                                        <div class="flex align-items-center gap-2">
                                            <span class="Raleway-Medium mb-2" v-if="student.subjects?.length > 0">
                                                {{student.subjects.map(s => cleanupLables(s)).join(', ')}}
                                            </span>
                                        </div>
                                        <div class="flex align-items-center w-full gap-2 mt-1">
                                            <Button label="View Profile" class="accent-button mb-2 w-full" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="text-center">
                            <i class="pi pi-inbox" style="font-size: 2rem; color: var(--surface-400)"></i>
                            <p class="mt-2 text-color-secondary">No enrolled students found</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, onMounted } from "vue";
import Button from 'primevue/button';
import { generateSignedUrl } from '@/api/storage';
import blankProfile from '@/assets/blank-profile.png';
import { cleanupLables } from "@/utils/cleanups";
const props = defineProps({
    enrolledStudents: null
})

onMounted(async () => {
    if (!props.enrolledStudents?.length) return;

    for (const student of props.enrolledStudents) {
        // UPDATED: Check for studentPhotoURL (from API) instead of tutorPhotoURL
        if (student.studentPhotoURL && !student.profilePhoto) {
            try {
                student.profilePhoto = await generateSignedUrl(student.studentPhotoURL);
            } catch (err) {
                student.profilePhoto = blankProfile;
            }
        } else if (!student.profilePhoto) {
            student.profilePhoto = blankProfile;
        }
    }
});
</script>

<style scoped>
.black-btn {
    color: var(--gray-600) !important;
}

.black-btn:hover {
    color: var(--gray-600) !important;
    background-color: var(--black-50) !important;
}
</style>